import { useSelector } from 'react-redux';
// import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import classes from './FinishedCourseMessage.module.css';

// const url = window.location.pathname.split('/');

const FinishedCourseMessage = () => {
  const dataUser = useSelector(state => state.userInfo);
  //   const { t } = useTranslation(['lesson']);

  return (
    <div className={classes.finishedCourseContainer}>
      <p className={classes.title}>
        !Felicidades, {dataUser.data.nombre}!
      </p>
      <p className={classes.subtitle}>
        Completaste con éxito tu curso
      </p>
      <p className={classes.complementaryInfo}>
        Recuerda: si tu curso entrega diploma, podrás encontrarlo en
        Mis Diplomas
      </p>
      <Button
        className={classes.btnDegree}
        component="a"
        href={`${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myPortfolio`}
      >
        Ir a Mis Diplomas
      </Button>
    </div>
  );
};

FinishedCourseMessage.propTypes = {};

export default FinishedCourseMessage;
